import { useState } from 'react';

export interface VolunteerContactField {
	key: 'name' | 'email' | 'phone' | 'birthday' | 'address';
	collect: boolean;
	require: boolean;
	locked?: boolean;
}

const INITIAL_FIELDS: VolunteerContactField[] = [
	{ key: 'name', collect: true, require: true, locked: true },
	{ key: 'email', collect: true, require: true, locked: true },
	{ key: 'phone', collect: false, require: false },
	{ key: 'birthday', collect: false, require: false },
	{ key: 'address', collect: false, require: false },
];

export function useVolunteerFormDraft(): {
	contactFields: VolunteerContactField[];
	setContactField(key: VolunteerContactField['key'], patch: Partial<VolunteerContactField>): void;
} {
	const [contactFields, setContactFields] = useState<VolunteerContactField[]>(INITIAL_FIELDS);

	function setContactField(key: VolunteerContactField['key'], patch: Partial<VolunteerContactField>): void {
		setContactFields(prev => prev.map(f => (f.key === key ? { ...f, ...patch } : f)));
	}

	return { contactFields, setContactField };
}
